module.exports = __webpack_public_path__ + "static/media/arwor-right-grey.2b9ac5cb.svg";